<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef> Provisiesoort </th>
    <td mat-cell *matCellDef="let data">{{data.type ? data.type : emptyValuePlaceholder}}</td>
  </ng-container>

  <ng-container matColumnDef="percentage">
    <th mat-header-cell *matHeaderCellDef> Percentage </th>
    <td mat-cell *matCellDef="let data">{{data.percentage ? data.percentage : emptyValuePlaceholder}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
